<!-- 文献详情页 -->
<template>
  <div id="decipherDetail"> 
    <Header></Header>
    <div class="new-breadcrumb">
      <ScienceBreadcrumb :text="text"></ScienceBreadcrumb> 
    </div>
    <div class="science-box">
      <div id="img-content" class="rich_media_wrp">
        <h1 class="rich_media_title" id="activity-name">
          {{ decipherInfo.title }} 
        </h1>
        <div class="decipher-content" v-html="decipherInfo.content"></div>
      </div>
    </div>
    <div class="footer"> 
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import Header from "../componets/Header.vue";
import Footer from "../componets/Footer.vue";
import ScienceBreadcrumb from "../componets/ScienceBreadcrumb.vue";
import api from "../../api/api";
export default {
  name: "decipherDetail",
  props: {},
  components: {
    Header,
    Footer,
    ScienceBreadcrumb,
  },
  data() {
    return {
      text: "文献解读详情",
      decipherInfo: {},
    };
  },
  created() {
    let id = this.$route.params.id;
    // console.log(id);
    this.getDetailsDecipher(id);
  },
  mounted() {
     
  },
  watch: {},
  methods: {
    getDetailsDecipher(id) {
      api
        .getDecipherById(id)
        .then((res) => {
          console.log(res.data);
          this.decipherInfo = res.data.models[0];
        })
        .catch((error) => {});
    },
  },
};
</script>
    
<style lang="scss">
#decipherDetail {
  .new-breadcrumb {
    padding-top: 5rem;
  }
  .science-box {
    position: relative;
    width: 65%;
    // padding-top: 5rem;
    margin: auto;
    .rich_media_title {
      font-size: 1.375rem;
      // line-height: 1.4;
      margin-bottom: 1rem;
      text-align: center;
    }
    .decipher-content {
      // white-space: pre-wrap;
      font-family: "Microsoft Yahei";
      font-size: 1.125rem;
      color: #333;
      p {
        line-height: 2;
      }
    }
  }
  .footer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 6.25rem 8% 3.125rem;
  }
  .decipher-content {
    img {
      max-width: 100%!important;
      display: block!important;
      margin: 20px auto!important;
    }
    // p {
    //   font-family: "OPlusSans3-Regular";
    // }
    .ql-align-left {
      text-align: left;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
  }
}
</style>